import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StyledThumbnailsToggle } from './styles';
import { StoreState } from '../../../reducers';
import Utils from '../../../utils';
import { toggleThumbnails } from '../../../containers/Editor/actions';

interface ThumbnailsToggleProps {
	isOpened: boolean;
	dispatch: Dispatch<StoreState>;
}

const ThumbnailsToggle = ({ isOpened, dispatch }: ThumbnailsToggleProps) => (
	<StyledThumbnailsToggle
		type="button"
		isOpened={isOpened}
		onClick={() => dispatch(toggleThumbnails())}
	>
		{Utils.getSvgIcon('iconset_back')}
	</StyledThumbnailsToggle>
);

export default ThumbnailsToggle;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ThumbnailsToggle/index.tsx